<template>
  <div>
    <upload-file v-model="files" btnType="line" btnColor="success" class="w-full m-2" :btnText="$t(text) | capitalize"
      accept=".xlsx" @input="upload" :disabled="disabled" />
  </div>
</template>

<script>
import UploadFile from '@/views/components/UploadFile.vue'
import request from './request.js'
export default {
  components: {
    UploadFile
  },
  props: {
    expense_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: 'upload_file',
      disabled: false,
      files: [],
    }
  },

  methods: {
    upload() {
      this.text = 'loading...'
      const data = new FormData()
      data.append('expense_id', this.expense_id)
      this.files.forEach(function (file, i) {
        data.append('files[]', file)
      })
      request
        .uploadAttachment(data)
        .then((res) => {
          this.files = []
          this.text = 'upload'
          this.$emit('success')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Uploaded File',
          })
        })
        .catch((err) => {
          this.files = []
          this.text = 'upload'
          this.$vs.notify({
            color: 'warning',
            title: 'Alert',
            text: 'Upload Error',
          })
        })
    },
  }
}
</script>

<style></style>